import {
  disableClientObservability,
  initializeClientObservability,
  recordClientOperationalEvent,
} from "@/src/client/observability/axiomClient";
import { isTelemetryAllowedInBrowser, subscribeToConsent } from "@/src/features/consent/browserConsent";

// Axiom browser diagnostics are the "diagnostics" consent category: they start
// only after an opt-in, and stop (buffer discarded) when it is withdrawn. On
// a device that last hydrated a HIPAA account they stay off before the
// verified session resolves (the HIPAA device hint in browserConsent).
function applyDiagnosticsConsent(): void {
  if (isTelemetryAllowedInBrowser("diagnostics")) initializeClientObservability();
  else disableClientObservability();
}

applyDiagnosticsConsent();
subscribeToConsent(applyDiagnosticsConsent);

export function onRouterTransitionStart(url: string): void {
  recordClientOperationalEvent({
    event_name: "browser.navigation.started",
    severity: "info",
    route: url,
  });
}
